import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchClientServiceDetails, clientServiceAddFavourites, clientServiceRemoveFavourites } from '../slice/clientServiceDetailsSlice';
import BookAppointmentModal from '../../book-appointment/components/index';
import ClietHeader from "../../client-header/components/index";
import ClietFooter from "../../client-footer/components/index";
import { format, parse } from 'date-fns';
import ClientMapComponent from "../../client-map/components/index";
import { useLoadScript } from '@react-google-maps/api';
import { toast } from "react-toastify";
import { selectClientAuth, logout } from "../../auth-client/slice/clientAuth";
import { getClientInfo } from "../../client-panel/slice/clientPanelInfoSlice";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faStar as fullStar,
  faStarHalfAlt as halfStar
} from '@fortawesome/free-solid-svg-icons';
import { faStar as emptyStar } from '@fortawesome/free-regular-svg-icons';

const libraries = ['places'];

const isTokenValid = () => {
  const expiryTime = localStorage.getItem("client_token_expiry");
  if (!expiryTime) return false;

  const currentTime = new Date().getTime();
  return currentTime < parseInt(expiryTime);
};

const ClientServiceDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { loading, error, clientServiceDetails } = useSelector((state) => state.clientServiceDetails);
  const [showModal, setShowModal] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showBookAppointmentModal, setShowBookAppointmentModal] = useState(false);
  const [isFavourite, setIsFavourite] = useState(false);
  const isClientLoggedIn = useSelector(selectClientAuth);
  const isVerified = useSelector((state) => state.clientInfo.isClientVerified);

  console.log("isVerified", isVerified);

  useEffect(() => {
    dispatch(fetchClientServiceDetails(id));
  }, [id]);

  const token = localStorage.getItem("client_access_token");
  
    useEffect(() => {
      if (!token) {
        dispatch(getClientInfo(token));
      }
    }, [dispatch, token]);

  useEffect(() => {
   if (clientServiceDetails?.hasFavorite !== undefined) {
      setIsFavourite(clientServiceDetails.hasFavorite === 1);
   }
   }, [clientServiceDetails]);

       useEffect(() => {
    if (showBookAppointmentModal) {
      document.body.classList.add("modal-open");
      document.body.style.overflow = "hidden";
    } else {
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    }
      return () => {
    // Cleanup on unmount
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
  };
}, [showBookAppointmentModal]);


  const formatTo12Hour = (timeStr) => {
    const [hours, minutes] = timeStr.split(':');
    const date = new Date();
    date.setHours(+hours, +minutes);
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    }).format(date);
  };

 const handleToggleFavourite = async () => {
  try {
    if (isFavourite) {
      // Remove from favourites
      await dispatch(clientServiceRemoveFavourites({ service_id: id })).unwrap();
      setIsFavourite(false);
      toast.success("Removed from favourites", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
    } else {
      // Add to favourites
      await dispatch(clientServiceAddFavourites({ service_id: id })).unwrap();
      setIsFavourite(true);
      toast.success("Added to favourites", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
    }
  } catch (error) {
    toast.error("Failed to update favourites", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
  }
};


  const { isLoaded, loadError } = useLoadScript({
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
      libraries,
    });

  const formatTime = (time: string) => {
   const parsed = parse(time, 'HH:mm:ss', new Date());
   return format(parsed, 'h:mm a');
   };

     {showBookAppointmentModal && (
       <BookAppointmentModal
         client={clientServiceDetails}
         onClose={() => setShowBookAppointmentModal(false)}
       />
     )}

   const formatList = (items: string[]): string => {
      if (!items || items.length === 0) return 'None';
      const capitalized = items.map(item => item.charAt(0).toUpperCase() + item.slice(1));
      if (capitalized.length === 1) return capitalized[0];
      if (capitalized.length === 2) return capitalized.join(' and ');
      return `${capitalized.slice(0, -1).join(', ')} and ${capitalized.at(-1)}`;
   };

   const today = new Date().toLocaleDateString('en-US', { weekday: 'long' });

  if (loading) return <p className="loading">Loading...</p>;
  if (error) return <p className="error">{error}</p>;
  if (!clientServiceDetails) return <p className="no-data">No data found.</p>;

  console.log("clientServiceDetails", clientServiceDetails);

   const languages = clientServiceDetails.language_support.map(lang => lang.value);
   const additional_tags = clientServiceDetails.additional_tags.map(tag => tag.value);
   const service_description = clientServiceDetails.service_description;

   const IMAGE_BASE_URL = process.env.REACT_APP_PROVIDER_IMAGE_BACKEND_URL;
   const images = clientServiceDetails?.provider?.images || [];
   const visibleImages = showAll ? images : images.slice(0, 6);

   const videos = clientServiceDetails?.provider?.videos || [];
   const visibleVideos = showAll ? videos : videos.slice(0, 6);

   const openModal = (index) => {
    setCurrentIndex(index);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const showNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const showPrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

//   if (!clientServiceDetails || !clientServiceDetails.provider) return null;

   // Extract lat/lng safely
   const lat = parseFloat(clientServiceDetails.provider.lat);
   const lng = parseFloat(clientServiceDetails.provider.long);

   // Fallback if lat/lng is invalid
   const hasValidCoordinates = !isNaN(lat) && !isNaN(lng);

   const center = hasValidCoordinates ? { lat, lng } : { lat: 0, lng: 0 }; // Default center if invalid
   const markers = hasValidCoordinates
  ? [
      {
        lat,
        lng,
        name: clientServiceDetails.provider.company_name,
        address: clientServiceDetails.provider.address,
        city: clientServiceDetails.provider.city,
        state: clientServiceDetails.provider.state
      }
    ]
  : [];

  const handleOpenAppointmentModal = () => {
    const tokenValid = isTokenValid();

    

    if (!isClientLoggedIn || !tokenValid) {

      toast.error("Please login to book an appointment", {
         position: "top-right",
         autoClose: 2000,
         style: { fontSize: "0.85rem" },
      });

      dispatch(logout());
      localStorage.removeItem("client_access_token");
      localStorage.removeItem("client_token_expiry");
      localStorage.removeItem("user_id");

      navigate("/signin");
      return;
    }

    if (!isVerified) {
      toast.info("Please verify your account to book an appointment", {
         position: "top-right",
         autoClose: 2000,
         style: { fontSize: "0.85rem" },
      });
      navigate("/panel/verify");
      return; // don't open the modal
   }

    setShowBookAppointmentModal(true);
  };

  const handleChatComponent = () => {
    const tokenValid = isTokenValid();

    if (!isClientLoggedIn || !tokenValid) {

      toast.error("Please login to chat with provider", {
         position: "top-right",
         autoClose: 2000,
         style: { fontSize: "0.85rem" },
      });

      dispatch(logout());
      localStorage.removeItem("client_access_token");
      localStorage.removeItem("client_token_expiry");
      localStorage.removeItem("user_id");

      navigate("/signin");
      return;
    }

    const providerId = clientServiceDetails.provider_id;
    navigate(`/client/chat/provider/${providerId}`);
  };


  return (
    <>
    <style>{`
      .modal-backdrop-custom {
          position: fixed;
          top: 0;
          left: 0;
          z-index: 1040;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.5);
          overflow: auto;
      }
    `}
    </style>

    {showBookAppointmentModal && <div className="modal-backdrop-custom"></div>}
    {showBookAppointmentModal && (
            <BookAppointmentModal
              client={clientServiceDetails}
              onClose={() => setShowBookAppointmentModal(false)}
            />
          )}
        <ClietHeader />
        <main className="overflow-hidden">
         <section className="homepad pb-5">
            <div className="container">
               <div className="position-relative misson-box overflow-hidden rounded22" style={{ background: `url(/assets/images/misson-bg.jpg) no-repeat` }}>
                  <div className="position-relative p-4 p-lg-5 m-2 m-md-4 m-lg-5">
                     <div className="font-size-22 font-weight-normal line-hight-3 text-white ps-lg-4 col-12 text-center">
                        <h2 className="font-weight-bold montserrat text-white font-size-50 mb-3 line-hight-2">Number Sense Routines Virtual Fall 1 Session 2025</h2>
                        Lorem Ipsum is simply dummy text of the!
                     </div>
                  </div>
               </div>
            </div>
         </section>
         <section className="homepad pt-0">
            <div className="container">
               <div className="row">
                  {/* <!-- Right Column: Map and Help --> */}
                  <div className="col-lg-4">
                     <div className="profile-card text-center bg-light rounded22 p-4">
                        <div className="p-1 p-sm-3">
                           {/* <!-- Profile Picture --> */}
                           {clientServiceDetails?.provider?.profile_image && (
                              <img
                                 src={`${process.env.REACT_APP_PROFILE_IMAGE_BACKEND_URL}/${clientServiceDetails.provider.profile_image}`}
                                 className="avatar mb-3 img-fluid"
                                 alt="User"
                              />
                           )}
                           {/* <!-- Name & Title --> */}
                           <h5 className="text-center mb-2 font-weight-bold text-primary font-size-28 line-hight-2 montserrat">
                              {clientServiceDetails.provider.company_name}
                           </h5>
                           <p className="mb-0 text-danger-dark font-weight-medium font-size-22">
                              {clientServiceDetails.provider.contact_name}
                           </p>
                           {/* <!-- Phone Number --> */}
                           <div className="my-3 pt-2">
                              <a
                                 href={`tel:${clientServiceDetails.provider.contact_number}`}
                                 className="text-graydark font-weight-semibold font-size-24 text-decoration-none"
                              >
                                 <i className="fa fa-phone me-1"></i>
                                 {clientServiceDetails.provider.contact_number}
                              </a>
                           </div>
                           {/* <!-- Social Icons --> */}
                           <div className="social-icons">
                              <button type="button" className="btn btn-outline-danger rounded-circle me-1"><i className="fa fa-envelope"></i></button>
                              <button type="button" className="btn btn-outline-danger rounded-circle me-1"><i className="fa fa-instagram"></i></button>
                              <button type="button" className="btn btn-outline-danger rounded-circle me-1"><i className="fa fa-facebook"></i></button>
                              <button type="button" className="btn btn-outline-danger rounded-circle"><i className="fa fa-linkedin"></i></button>
                           </div>
                           <div className="py-4 my-sm-3">
                              <hr className="m-0"/>
                           </div>
                           {/* <!-- Price --> */}
                           <p className="price mb-1 font-weight-semibold font-size-26">
                              ${clientServiceDetails.charge_per_week} per week
                           </p>
                           <p className="price-sub mb-3 font-weight-medium font-size-18 text-danger-dark">
                              ${clientServiceDetails.amount} per month</p>
                           <div className="py-1 py-sm-3">
                           </div>
                           {/* <!-- Action Buttons --> */}
                           <button className="btn btn-custom-primary font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded w-100" onClick={handleOpenAppointmentModal}><span className="d-block py-2"><i className="fa fa-calendar-o me-1"></i> Book Appointment</span></button>
                           <button className="btn btn-custom-primary font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded w-100 my-3" onClick={handleChatComponent}><span className="d-block py-2"><i className="fa fa-commenting-o me-1"></i> Message Provider</span></button>
                           <button
                              className={`btn ${isFavourite ? "btn-secondary" : "btn-danger"} font-weight-medium font-size-18 text-capitalize px-3 px-md-4 rounded w-100`}
                              onClick={handleToggleFavourite}
                              >
                              <span className="d-block py-2">
                                 <i className={`fa ${isFavourite ? "fa-heart-broken" : "fa-heart"} me-1`}></i>
                                 {isFavourite ? "Remove From Favourites" : "Add To Favourites"}
                              </span>
                           </button>
                        </div>
                     </div>
                     <div className="py-2">
                        <div className="schedule-box text-start my-4 bg-primary rounded22 p-4 text-white font-size-18">
                           {Array.isArray(clientServiceDetails.provider?.worktimes) && clientServiceDetails.provider.worktimes.length > 0 ? (
                              clientServiceDetails.provider.worktimes.map(({ day, checked, opening_hours, closing_hours }) => {
                                 const isToday = day === today;
                                 const isOpen = checked === 'Y';

                                 return (
                                 <div
                                    key={day}
                                    className={`d-flex justify-content-between py-2 ${
                                       isToday ? 'text-danger-dark font-weight-semibold' : ''
                                    }`}
                                 >
                                    <span className="font-weight-semibold">{isToday ? 'Today' : day.slice(0, 3)}</span>
                                    <span>
                                       {isOpen
                                       ? `${formatTime(opening_hours)} - ${formatTime(closing_hours)}`
                                       : 'Closed'}
                                    </span>
                                 </div>
                                 );
                              })
                           ) : (
                              <div className="py-2">No work time found</div>
                           )}
                        </div>

                     </div>
                     {/* <!-- Map --> */}
                     {isLoaded && (
                        <div className="map-box rounded15 overflow-hidden" style={{ height: "30%" }}>
                           <ClientMapComponent center={center} markers={markers} />
                        </div>
                      )}
                  </div>
                  <div className="col-lg-8 services-listpage mt-4 mt-lg-0" style={{ minHeight: "1500px" }}>
                     <div className="ps-lg-4">
                        <div className="generated rounded22 p-4">
                           <div className="py-sm-1 px-sm-1 d-flex align-items-center">
                              {/* <!-- Profile Picture --> */}
                              <div className="me-3 me-sm-4"><img src="/assets/images/generated-svg.svg" className="img-fluid" alt="User"/></div>
                              <div className="font-size-18 text-primary">
                                 <b className="font-weight-semibold">
                                    Accepting new enrollments:
                                 </b>
                                 &nbsp;{clientServiceDetails.from_age} to {clientServiceDetails.to_age} years
                                 {/* {clientServiceDetails.from_age} - {clientServiceDetails.to_age} Years */}
                              </div>
                           </div>
                        </div>
                        {/* <!-- Header --> */}
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mt-4">
                           <div className="d-flex align-items-center">
                              <div className="me-3"><i className="fa fa-calendar-o me-1 text-danger-dark font-size-18"></i></div>
                              <div>
                                 <div className="text-muted font-size-16">
                                    <strong className="d-block mb-2 font-weight-bold text-primary font-size-16 line-hight-2 montserrat">
                                       Program Type
                                    </strong>
                                    {clientServiceDetails.issueType.issue_type}
                                 </div>
                              </div>
                           </div>
                           <div className="mt-4 mt-sm-0">
                              <button className="btn btn-danger font-weight-semibold" onClick={handleOpenAppointmentModal}><span className="d-block py-1 px-2"><i className="fa fa-calendar"></i> Book Appointment</span></button>
                           </div>
                        </div>
                        <div className="py-4 my-3">
                           <hr className="m-0" style={{ opacity: 0.1 }} />
                        </div>
                        <h5 className="mb-3 pb-1 font-weight-semibold text-primary font-size-28 line-hight-2 montserrat">Basics</h5>
                        <div className="bg-light rounded22 p-4 mb-4">
                           <div className="p-sm-2">
                              <div className="row g-3 g-sm-4">
                                 <div className="col-sm-6">
                                    <div className="d-flex align-items-center">
                                       <div className="me-3"><i className="fa fa-calendar-o me-1 text-danger-dark font-size-18"></i></div>
                                       <div>
                                          <div className="text-muted font-size-16">
                                             <strong className="d-block mb-2 font-weight-bold text-primary font-size-16 line-hight-2 montserrat">
                                                Age:
                                             </strong>
                                             {clientServiceDetails.from_age} - {clientServiceDetails.to_age} Years
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-sm-6">
                                    <div className="d-flex align-items-center">
                                       <div className="me-3"><i className="fa fa-clock-o me-1 text-danger-dark font-size-18"></i></div>
                                       <div>
                                          <div className="text-muted font-size-16">
                                             <strong className="d-block mb-2 font-weight-bold text-primary font-size-16 line-hight-2 montserrat">
                                                Hours:
                                             </strong>
                                             {clientServiceDetails.daily_hours?.slice(0, 5)}
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-sm-6">
                                    <div className="d-flex align-items-center">
                                       <div className="me-3"><i className="me-1 text-danger-dark font-size-18"><img src="/assets/images/pay-schedules.svg" className="img-fluid" alt="User"/></i></div>
                                       <div>
                                          <div className="text-muted font-size-16"><strong className="d-block mb-2 font-weight-bold text-primary font-size-16 line-hight-2 montserrat">Pay schedules:</strong>Monthly or weekly</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-sm-6">
                                    <div className="d-flex align-items-center">
                                       <div className="me-3"><i className="me-1 text-danger-dark font-size-18"><img src="/assets/images/meals-icon.svg" className="img-fluid" alt="User"/></i></div>
                                       <div>
                                          <div className="text-muted font-size-16">
                                             <strong className="d-block mb-2 font-weight-bold text-primary font-size-16 line-hight-2 montserrat">
                                                Meals:
                                             </strong>
                                             {formatList(clientServiceDetails.meals)}
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-sm-6">
                                    <div className="d-flex align-items-center">
                                       <div className="me-3">
                                          <i className="me-1 text-danger-dark font-size-18">
                                             <img src="/assets/images/pottytraining-icon.svg" className="img-fluid" alt="User"/>
                                          </i>
                                       </div>
                                    <div>
                                    <div className="text-muted font-size-16">
                                       <strong className="d-block mb-2 font-weight-bold text-primary font-size-16 line-hight-2 montserrat">
                                          Additional training:
                                       </strong>
                                          {additional_tags.map((tag, index) => (
                                             <span key={index} className="badge bg-primary text-white me-2 font-size-16">
                                                {tag}
                                             </span>
                                          ))}
                                    </div>
                                 </div>
                                    </div>
                                 </div>
                                 <div className="col-sm-6">
                                    <div className="d-flex align-items-center">
                                       <div className="me-3">
                                          <i className="fa fa-globe me-1 text-danger-dark font-size-20"></i>
                                       </div>
                                       <div>
                                          <div className="text-muted font-size-16">
                                          <strong className="d-block mb-2 font-weight-bold text-primary font-size-16 line-hight-2 montserrat">
                                             Language(s) Supported: 
                                             <i className="fa fa-info-circle ms-2 text-danger-dark font-size-16"></i>
                                          </strong>
                                          
                                          {/* Display each language as a badge */}
                                          {languages.map((lang, index) => (
                                             <span key={index} className="badge bg-primary text-white me-2 font-size-16">
                                                {lang}
                                             </span>
                                          ))}

                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <h5 className="mb-3 pb-1 font-weight-semibold text-primary font-size-28 line-hight-2 montserrat pt-3">Photos</h5>
                        {/* <div className="row g-3 row-cols-2 row-cols-sm-3 row-cols-md-3 g-lg-4 gallery-row">
                           {visibleImages.map((img, index) => (
                              <div className="col" key={index}>
                                 <div
                                 className="gallery-item"
                                 onClick={() => openModal(index)}
                                 style={{ cursor: 'pointer' }}
                                 >
                                 <img
                                    src={`${IMAGE_BASE_URL}/${img.image_name}`}
                                    className="img-thumbnail"
                                    alt={`Gallery ${index}`}
                                    style={{ height: '300px', objectFit: 'cover', width: '100%' }}
                                 />
                                 <div className="overlay">
                                    <i className="fa fa-search-plus"></i>
                                 </div>
                                 </div>
                              </div>
                           ))}
                        </div> */}
                        <div className="row g-3 row-cols-2 row-cols-sm-3 row-cols-md-3 g-lg-4 gallery-row">
                           {visibleImages.length === 0 ? (
                              <div className="col-12 text-center text-muted py-4">
                                 No images available
                              </div>
                           ) : (
                              visibleImages.map((img, index) => (
                                 <div className="col" key={index}>
                                 <div
                                    className="gallery-item"
                                    onClick={() => openModal(index)}
                                    style={{ cursor: 'pointer' }}
                                 >
                                    <img
                                       src={`${IMAGE_BASE_URL}/${img.image_name}`}
                                       className="img-thumbnail"
                                       alt={`Gallery ${index}`}
                                       style={{ height: '300px', objectFit: 'cover', width: '100%' }}
                                    />
                                    <div className="overlay">
                                       <i className="fa fa-search-plus"></i>
                                    </div>
                                 </div>
                                 </div>
                              ))
                           )}
                        </div>

                        {/* Show more/less button */}
                        {images.length > 6 && (
                        <div className="my-4">
                           <button
                              className="btn btn-danger font-weight-semibold"
                              onClick={() => setShowAll((prev) => !prev)}
                           >
                              <span className="d-block py-1 px-2">
                              {showAll ? 'Show less photos' : 'Show all photos'}
                              </span>
                           </button>
                        </div>
                        )}

                        {/* Modal */}
                        <div
                        className={`modal fade ${showModal ? 'show' : ''}`}
                        style={{
                           display: showModal ? 'block' : 'none',
                           backgroundColor: 'rgba(0,0,0,0.7)',
                        }}
                           tabIndex="-1"
                           aria-hidden={!showModal}
                           onClick={closeModal} // close when clicking backdrop
                           >
                           <div
                              className="modal-dialog modal-dialog-centered modal-lg"
                              onClick={(e) => e.stopPropagation()} // don't close modal when clicking inside
                           >
                              <div className="modal-content">
                                 <div className="modal-body text-center position-relative">
                                 {/* Close Button */}
                                 <button
                                    type="button"
                                    className="close-button"
                                    aria-label="Close"
                                    onClick={closeModal}
                                    style={{ color: "white" }}
                                 ><i className="fa fa-times"></i></button>

                                 {/* Prev Button */}
                                 <button
                                    className="nav-btn prev-btn"
                                    onClick={showPrev}
                                    aria-label="Previous image"
                                 >
                                    <i className="fa fa-chevron-left"></i>
                                 </button>

                                 {/* Image */}
                                 <img
                                    id="modalImage"
                                    src={`${IMAGE_BASE_URL}/${images[currentIndex]?.image_name}`}
                                    alt={`Gallery image ${currentIndex + 1}`}
                                    className="modal-img"
                                    style={{ height: "880px" }}
                                 />

                                 {/* Next Button */}
                                 <button
                                    className="nav-btn next-btn"
                                    onClick={showNext}
                                    aria-label="Next image"
                                 >
                                    <i className="fa fa-chevron-right"></i>
                                 </button>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <h5 className="mb-3 pb-1 font-weight-semibold text-primary font-size-28 line-hight-2 montserrat pt-3">videos</h5>
                        <div className="row g-3 row-cols-2 row-cols-sm-3 row-cols-md-3 g-lg-4 video-gallery">
                           {visibleVideos && visibleVideos.length > 0 ? (
                              visibleVideos.map((video, i) => {
                                 const url = video.video_url.trim();

                                 if (url.includes('youtube.com/shorts/')) {
                                 const videoId = url.split('/shorts/')[1];
                                 return (
                                    <div key={i} className="col video-wrapper">
                                       <iframe
                                       width="100%"
                                       height="215"
                                       src={`https://www.youtube.com/embed/${videoId}`}
                                       title={`Provider Video ${i + 1}`}
                                       frameBorder="0"
                                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                       allowFullScreen
                                       className="rounded img-thumbnail"
                                       />
                                    </div>
                                 );
                                 }

                                 if (url.includes('youtube.com/watch?v=')) {
                                 const videoId = new URLSearchParams(url.split('?')[1]).get('v');
                                 return (
                                    <div key={i} className="col video-wrapper">
                                       <iframe
                                       width="100%"
                                       height="215"
                                       src={`https://www.youtube.com/embed/${videoId}`}
                                       title={`Provider Video ${i + 1}`}
                                       frameBorder="0"
                                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                       allowFullScreen
                                       className="rounded img-thumbnail"
                                       />
                                    </div>
                                 );
                                 }

                                 if (/\.(mp4|webm|ogg)$/i.test(url)) {
                                 return (
                                    <div key={i} className="col video-wrapper">
                                       <video
                                       width="100%"
                                       height="215"
                                       controls
                                       className="rounded img-thumbnail"
                                       >
                                       <source src={url} type={`video/${url.split('.').pop()}`} />
                                       Your browser does not support the video tag.
                                       </video>
                                    </div>
                                 );
                                 }

                                 return (
                                 <div key={i} className="col video-wrapper">
                                    <p>Unsupported video format or URL: {url}</p>
                                 </div>
                                 );
                              })
                           ) : (
                              <p className="text-center w-100">No videos available.</p>
                           )}
                           </div>

                           {videos.length > 6 && (
                           <div className="mt-4">
                              <button
                                 className="btn btn-danger font-weight-semibold"
                                 onClick={() => setShowAll((prev) => !prev)}
                              >
                                 <span className="d-block py-1 px-2">
                                 {showAll ? 'Show less videos' : 'Show all videos'}
                                 </span>
                              </button>
                           </div>
                           )}
                        {/* <!-- Descriptions --> */}
                        <div className="description-section">
                           <div className="pt-4  font-weight-normal line-hight-3">
                              <h5 className="mb-3 pb-1 font-weight-semibold text-primary font-size-28 line-hight-2 montserrat pt-3">Description</h5>
                              <div
                                 className="text-dark"
                                 dangerouslySetInnerHTML={{ __html: service_description }}
                              ></div>
                           </div>
                           <div className="py-4 my-2">
                               <hr className="m-0" style={{ opacity: 0.1 }} />
                            </div>

                           <div>
                              {clientServiceDetails.provider.clientReview && clientServiceDetails.provider.clientReview.length > 0 ? (
                                 clientServiceDetails.provider.clientReview.map((review, i) => (
                                    <div key={i} className="review-card">
                                       <div className="review-header mb-2">
                                          <div className="review-user">
                                             <img src="https://i.pravatar.cc/40?img=1" alt="user" />
                                             <h6 className="mb-0 montserrat font-weight-semibold">{`${review.clients?.first_name ?? ''} ${review.clients?.last_name ?? ''}`.trim()}</h6>
                                          </div>
                                       </div>
                                       <div class="review-meta my-3 pt-1">
                                          <div class="star-rating">
                                             <span style={{ marginLeft: '8px', color: '#f5c518' }}>
                                                {
                                                   (() => {
                                                      const fullStars = Math.floor(review.avg_rating);
                                                      const hasHalfStar = review.avg_rating % 1 >= 0.25 && review.avg_rating % 1 < 0.75;
                                                      const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
                              
                                                      return (
                                                      <>
                                                         {[...Array(fullStars)].map((_, i) => (
                                                            <FontAwesomeIcon key={`avg-full-${i}`} icon={fullStar} />
                                                         ))}
                                                         {hasHalfStar && <FontAwesomeIcon icon={halfStar} />}
                                                         {[...Array(emptyStars)].map((_, i) => (
                                                            <FontAwesomeIcon key={`avg-empty-${i}`} icon={emptyStar} />
                                                         ))}
                                                      </>
                                                      );
                                                   })()
                                                }
                                             </span>
                                          </div>
                                          <span className="review-date text-primary font-weight-medium">
                                             {new Date(review.review_date).toLocaleDateString('en-GB', {
                                                day: 'numeric',
                                                month: 'long',
                                                year: 'numeric',
                                             })}
                                          </span>
                                       </div>
                                       <p class="mb-0 font-size-16 font-weight-normal line-hight-3 text-muted">
                                          {review.review}
                                       </p>
                                    </div>
                                 ))
                              ) : (
                                 <p>No reviews available.</p>
                              )}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
         <ClietFooter />
      </main>
    </>
  );
};

export default ClientServiceDetails;
